import requestManager from '../platformApi/requestManager'
import appHelper from "@util/appHelper";

export default {

    getV1 : {
        url : 'portal/advertis/getAdvertisByType'
    },
    getV4 : {
        url : 'portal/v4/index/getAdvertisement'
    },

    click: function (id, callback) {
        return requestManager.request({
            url: 'portal/advertis/click',
            params: {
                id: id
            }
        }, callback);
    },

    clickApi : {
        url: 'portal/advertis/click',
    },

    /**
     * @param   {Object}    options
     * @param   {Function}  callback
     */
    getFreeAd(options, callback) {
        requestManager.request({
            url : 'portal/advertis/freeAd',
            data : options
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data.length ? result.data[0] : null);
        });
    },

    /**
     * @param   {String}    id
     * @param   {Function}  callback
     */
    datumAdFree(id, callback) {
        requestManager.request({
            url : 'portal/datum/adFree',
            method : 'post',
            data : {
                id : id
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    },

    /**
     * @param   {String}    id
     * @param   {Function}  callback
     */
    atlasAdFree(id, callback) {
        requestManager.request({
            url : 'portal/atlas/adFree',
            method : 'post',
            data : {
                id : id
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    }

};
